"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Phone, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FutureReadyAustralia() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="260436" id="future-ready-australia" className="relative w-full bg-background text-foreground">
      <div className="relative w-full min-h-[85vh] flex items-center justify-center bg-cover bg-center bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/students_learning_tech.png')]">
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/90 to-chart-2/80 mix-blend-multiply"></div>
        
        {}
        <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-6 py-20 text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="inline-block mb-6 px-4 py-1.5 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 text-sm md:text-base font-default font-semibold tracking-widest uppercase text-primary-foreground shadow-md">
            Sydney-Based Not-For-Profit
          </span>
          
          <h1 className="font-default text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-6 leading-tight text-primary-foreground max-w-4xl drop-shadow-xl tracking-tight">
            Empowering Communities Through Future-Ready Education
          </h1>
          
          <p className="font-default text-lg md:text-xl mb-10 max-w-2xl mx-auto text-primary-foreground/95 leading-relaxed font-medium">
            Future Ready Australia Ltd is a not-for-profit organisation based in Sydney, Australia. We are committed to empowering children, young people and communities through education, digital literacy, creative learning and future-ready skills.
            <br /><br />
            Our goal is to create accessible learning opportunities that help people build confidence, explore new ideas and prepare for a changing world.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center items-center">
            <Button size="lg" asChild className="bg-white text-primary hover:bg-white/90 w-full sm:w-auto text-base h-14 px-8 shadow-xl rounded-lg transition-transform hover:scale-105 active:scale-95">
              <Link to="#spotlight-ai-coding-classes">
                Our Programs
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" asChild className="border-2 border-white text-primary-foreground hover:bg-white/10 w-full sm:w-auto text-base h-14 px-8 bg-transparent shadow-xl rounded-lg backdrop-blur-sm">
              <Link to="#contact-details">
                Partner With Us
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}